import React, { useState, useRef } from "react";
import { Col, Container, Card, Row } from "react-bootstrap";
import Header from "./Header";
import MainSlider from "./MainSlider";
import Service from "./../../http";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import Slider from "react-slick";
import Image from "../../components/Image";
import PlayerDefaultImg from "./../../public/images/player_default_img.png";
import bannerimg1 from "./../../public/images/bg1.jpg";
import bannerimg2 from "./../../public/images/bg2.jpg";
import bannerimg3 from "./../../public/images/bg3.jpg";

import Footer from "./Footer";
import CountUp from "react-countup";

export default function Home() {
  const [players, setPlayers] = useState();
  const [center, setCenter] = useState();
  const [coach, setChoach] = useState();

  const services = new Service();

  const customeSliderPlayers = useRef();
  const customeSliderCoach = useRef();
  const customeSliderCenters = useRef();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],
  };

  React.useEffect(() => {
    services &&
      services.get("player/listview").then((res) => {
        setPlayers(res.data);
      });
  }, []);

  React.useEffect(() => {
    services &&
      services.get("coach/listview").then((res) => {
        setChoach(res.data);
      });
  }, []);

  React.useEffect(() => {
    services &&
      services.get("academy-center/academy?page=0&limit=10").then((res) => {
        setCenter(res.data.content);
      });
  }, []);

  React.useEffect(() => {
    const url = window.location.href.split("?zoom=");
    if (url.includes("?zoom=")) {
      const param = url[url.length - 1];
      document.querySelector("body").style.zoom = param;
      document.querySelector("body").style.pointerEvents = "none";
    }
  }, []);
  return (
    <div className="frontend">
      <Header />

      <MainSlider />
       {/*<section
        className="section bg-dark"
        style={{
          background: `url(${bannerimg3})`,
          backgroundSize: "cover",
          backgroundPosition: "55% 0%",
        }}
      >
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="pe-lg-5">
              <div className="section_heading text-white">
                <h3 className="mb-4">About Us</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Nullam pellentesque vel ante nec feugiat. Mauris rutrum justo
                  ligula, eu malesuada odio auctor eu. Lorem ipsum dolor sit
                  amet, consectetur adipiscing elit.
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Nullam pellentesque vel ante nec feugiat. Mauris rutrum justo
                  ligula, eu malesuada odio auctor eu. Vestibulum ante ipsum
                  primis in faucibus orci lerat molestie, id fringilla ipsum
                  varius.
                </p>
                <div className="d-sm-flex justify-content-around mt-5 text-center">
                  <div className="states_circle">
                    <h1 className="fw-bold mb-0">
                      <CountUp start={0} end={879} />
                    </h1>
                    <p className="mb-0">Total Players</p>
                  </div>
                  <div className="states_circle">
                    <h1 className="fw-bold mb-0">
                      <CountUp start={0} end={120} />
                    </h1>
                    <p className="mb-0">Total Coaches</p>
                  </div>
                  <div className="states_circle">
                    <h1 className="fw-bold mb-0">
                      <CountUp start={0} end={50} />
                    </h1>
                    <p className="mb-0">Total Centers</p>
                  </div>
                </div>
              </div>
            </Col>
             <Col md={6}>
              <Image
                src="https://www.pngmart.com/files/8/Tennis-PNG-Free-Image.png"
                className="mw-100"
              />
            </Col> 
          </Row>
        </Container> 
      </section>
*/}
      {/* <section className="section our_players">
        <Container>
          <Row className="align-items-center">
            <Col lg={4} className="pe-lg-5">
              <div className="section_heading">
                <h3 className="mb-4">Meet our players</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Nullam pellentesque vel ante nec feugiat. Mauris rutrum justo
                  ligula, eu malesuada odio auctor eu. Vestibulum ante ipsum
                  primis in faucibus orci lerat molestie, id fringilla ipsum
                  varius.
                </p>
              </div>
              <button
                className="nextBtn"
                onClick={() => customeSliderPlayers.current.slickNext()}
              >
                <IoIosArrowBack />
              </button>
              <button
                className="prevBtn"
                onClick={() => customeSliderPlayers.current.slickPrev()}
              >
                <IoIosArrowForward />
              </button>
            </Col>

            <Col lg={8}>
              <Slider {...settings} ref={customeSliderPlayers}>
                {players &&
                  players.map((i, index) => {
                    return (
                      <div className="px-2" key={index}>
                        <Card className=" profileCard position-sticky my-4">
                          <div className="profileCard-bg">
                            <div className="lg_image mx-auto bg-white">
                              <Image src={i.thumbnail} />
                            </div>
                          </div>
                          <Card.Body className="text-center">
                            <h6 className="profileCard-title text-dark mb-1">
                              {i.first_name_en + " " + i.last_name_en}
                            </h6>
                            <small className="d-block">
                              {i.first_name_other}
                              {i.last_name_other}
                            </small>
                          </Card.Body>
                        </Card>
                      </div>
                    );
                  })}
              </Slider>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className="section bg-dark"
        style={{ background: `url(${bannerimg3})`, backgroundSize: "cover" }}
      >
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="pe-lg-5">
              <div className="section_heading text-white">
                <h3 className="mb-4">Our Vision</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Nullam pellentesque vel ante nec feugiat. Mauris rutrum justo
                  ligula, eu malesuada odio auctor eu. Lorem ipsum dolor sit
                  amet, consectetur adipiscing elit. Nullam pellentesque vel
                  ante nec feugiat. Mauris rutrum justo ligula, eu malesuada
                  odio auctor eu. Vestibulum ante ipsum primis in faucibus orci
                  lerat molestie, id fringilla ipsum varius. Vestibulum ante
                  ipsum primis in faucibus orci lerat molestie, id fringilla
                  ipsum varius.
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Nullam pellentesque vel ante nec feugiat. Mauris rutrum justo
                  ligula, eu malesuada odio auctor eu. Lorem ipsum dolor sit
                  amet, consectetur adipiscing elit. Nullam pellentesque vel
                  ante nec feugiat. Mauris rutrum justo ligula, eu malesuada
                  odio auctor eu. Vestibulum ante ipsum primis in faucibus orci
                  lerat molestie, id fringilla ipsum varius. Vestibulum ante
                  ipsum primis in faucibus orci lerat molestie, id fringilla
                  ipsum varius.
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Nullam pellentesque vel ante nec feugiat. Mauris rutrum justo
                  ligula, eu malesuada odio auctor eu. Vestibulum ante ipsum
                  primis in faucibus orci lerat molestie, id fringilla ipsum
                  varius.
                </p>
              </div>
            </Col>
            
          </Row>
        </Container>
      </section>
      <section className="section our_players">
        <Container>
          <Row className="align-items-center">
            <Col lg={4} className="pe-lg-5">
              <div className="section_heading">
                <h3 className="mb-4">Meet our Coaches</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Nullam pellentesque vel ante nec feugiat. Mauris rutrum justo
                  ligula, eu malesuada odio auctor eu. Vestibulum ante ipsum
                  primis in faucibus orci lerat molestie, id fringilla ipsum
                  varius.
                </p>
              </div>
              <button
                className="nextBtn"
                onClick={() => customeSliderCoach.current.slickNext()}
              >
                <IoIosArrowBack />
              </button>
              <button
                className="prevBtn"
                onClick={() => customeSliderCoach.current.slickPrev()}
              >
                <IoIosArrowForward />
              </button>
            </Col>

            <Col lg={8}>
              <Slider {...settings} ref={customeSliderCoach}>
                {coach &&
                  coach.map((i, index) => {
                    return (
                      <div className="px-2" key={index}>
                        <Card className=" profileCard position-sticky my-4">
                          <div className="profileCard-bg">
                            <div className="lg_image mx-auto bg-white">
                              <Image
                                src={
                                  i.thumbnail
                                }
                                // src={
                                //   "http://files.leagueathletics.com/Images/Club/4284/Pics/_DSC3908.jpg"
                                // }
                              />
                            </div>
                          </div>
                          <Card.Body className="text-center">
                            <h6 className="profileCard-title text-dark mb-1">
                              {i.first_name_en + " " + i.last_name_en}
                            </h6>
                            <small className="d-block">
                              {i.first_name_other}
                              {i.last_name_other}
                            </small>
                          </Card.Body>
                        </Card>
                      </div>
                    );
                  })}
              </Slider>
            </Col>
          </Row>
        </Container>
      </section>
     
      <section className="section bg-white our_players">
        <Container>
          <Row className="align-items-center">
            <Col lg={4} className="pe-lg-5">
              <div className="section_heading">
                <h3 className="mb-4">Meet our Centers</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Nullam pellentesque vel ante nec feugiat. Mauris rutrum justo
                  ligula, eu malesuada odio auctor eu. Vestibulum ante ipsum
                  primis in faucibus orci lerat molestie, id fringilla ipsum
                  varius.
                </p>
              </div>
              <button
                className="nextBtn"
                onClick={() => customeSliderCenters.current.slickNext()}
              >
                <IoIosArrowBack />
              </button>
              <button
                className="prevBtn"
                onClick={() => customeSliderCenters.current.slickPrev()}
              >
                <IoIosArrowForward />
              </button>
            </Col>

            <Col lg={8}>
              <Slider {...settings} ref={customeSliderCenters}>
                {center &&
                  center.map((i, index) => {
                    return (
                      <div className="px-2" key={index}>
                        <Card className=" profileCard position-sticky my-4">
                          <div className="profileCard-bg">
                            <div className="lg_image mx-auto bg-white">
                              <Image src={PlayerDefaultImg} />
                            </div>
                          </div>
                          <Card.Body className="text-center">
                            <h6 className="profileCard-title text-dark mb-1">
                              {i.name_en}
                            </h6>
                            <small className="d-block">
                            
                              {i.name_other}
                            
                            </small>
                          </Card.Body>
                        </Card>
                      </div>
                    );
                  })}
              </Slider>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer /> */}
    </div>
  );
}
